<div class="edit-block mat-elevation-z1">
  <h2>{{ data.data.exercice.exercice.name }}</h2>
  <div class="inline-field">
    <mat-form-field color="primary" class="left-field">
      <mat-label>{{'seriePlaceholder' | translate}}</mat-label>
      <input matInput
             #serieNumber
             [formControl]="nbSerieFormControl"
             type="number"
             min="1"
             autocomplete="off">
      <mat-error *ngIf="nbSerieFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
      <mat-error *ngIf="nbSerieFormControl.hasError('min')">{{ 'Min_value' | translate: { value: serieMinValue } }}</mat-error>
    </mat-form-field>

    <mat-form-field color="primary" class="right-field">
      <mat-label>{{'repeatPlaceholder' | translate}}</mat-label>
      <input matInput
             #repeatNumber
             [formControl]="nbRepeatFormControl"
             type="number"
             min="1"
             autocomplete="off">
      <mat-error *ngIf="nbRepeatFormControl.hasError('required')">{{ 'Field_required' | translate }}</mat-error>
      <mat-error *ngIf="nbRepeatFormControl.hasError('min')">{{ 'Min_value' | translate: { value: repeatMinValue } }}</mat-error>
    </mat-form-field>
  </div>
  <mat-form-field color="primary">
    <mat-label>{{'payloadPlaceholder' | translate}}</mat-label>
    <input matInput
           [(ngModel)]="data.data.sessionItemExercice.payload!"
           type="number"
           min="0"
           (ngModelChange)="calcTotalPayload()"
           autocomplete="off">
    <span matSuffix>{{ sessionsProvider.SESSION_EXERCICE_PAYLOAD_UNIT }}</span>
  </mat-form-field>

  <duration-control [(value)]="data.data.sessionItemExercice.duration"
                    [label]="'repetitionDurationPlaceholder' | translate"
                    [displayMode]="'ms'"
                    (change)="onDurationChange()"
  >
  </duration-control>
  <duration-control [(value)]="data.data.sessionItemExercice.restTime"
                    [label]="'restTimePlaceholderAlt' | translate"
                    [displayMode]="'ms'"
                    (change)="onRestTimeChange()"
  >
  </duration-control>

  <div class="edit-totals">
    <div class="row">
      {{ 'totalTime' | translate }} : {{ baseComponent._totalTime | durationVerbose:'seconds' }}
    </div>
    <div class="row">
      {{ 'totalPayload' | translate }} : {{ baseComponent._totalPayload }} {{ sessionsProvider.SESSION_EXERCICE_PAYLOAD_UNIT | translate }}
    </div>
  </div>

  <div class="comment">
    <mat-form-field color="primary">
      <mat-label>{{'coachComment' | translate}}</mat-label>
      <textarea matInput
                cdkTextareaAutosize
                [(ngModel)]="data.data.sessionItemExercice.comment"
                (ngModelChange)="onCommentChange()"></textarea>
    </mat-form-field>
  </div>
</div>
